/**
 * `Stops.GeocodingType` values grouped as accurate (rooftop) or street-level; any other type is the
 * least-accurate group. Mirrors `Locate2u.AppPortal/Helpers/GeocodingAddressTypes.cs`, which drives
 * the Stops page geocoding filter, so the pin colour and the filter agree.
 */

// Azure Maps / Google names, the Cascader's Building and Shop (CORE-8044), Mapbox's address and poi,
// and Google location_type ROOFTOP / RANGE_INTERPOLATED from API callers (CORE-8308).
export const ACCURATE_ADDRESS_TYPES = [
    'Point Address',
    'street_number',
    'premise',
    'subpremise',
    'Address Range',
    'floor',
    'Building',
    'Shop',
    'Address',
    'poi',
    'point_of_interest',
    'establishment',
    'ROOFTOP',
    'RANGE_INTERPOLATED'
];

// Azure Maps / Google names, plus the Cascader's Road (CORE-8044).
export const STREET_ADDRESS_TYPES = ['Street', 'route', 'intersection', 'Cross Street', 'Road'];

// Case-insensitive, as SQL compares for the filter: Mapbox writes "address" and "street" (CORE-8308).
const toKeys = (types) => new Set(types.map((t) => t.toLowerCase()));
const ACCURATE_KEYS = toKeys(ACCURATE_ADDRESS_TYPES);
const STREET_KEYS = toKeys(STREET_ADDRESS_TYPES);

export const isAccurateAddressType = (type) => !!type && ACCURATE_KEYS.has(type.trim().toLowerCase());

export const isStreetAddressType = (type) => !!type && STREET_KEYS.has(type.trim().toLowerCase());
